const DISPLAY_ORDER = ['USD', 'EUR', 'GBP', 'CNY'];
const CBR_JSON_URL = 'https://www.cbr-xml-daily.ru/daily_json.js';

export const CODE_LABELS = {
  USD: 'USD → RUB',
  EUR: 'EUR → RUB',
  GBP: 'GBP → RUB',
  CNY: 'CNY (юань) → RUB',
};

export function sortRates(rates) {
  return [...(rates || [])].sort(
    (a, b) => DISPLAY_ORDER.indexOf(a.code) - DISPLAY_ORDER.indexOf(b.code),
  );
}

export function mapCbrDailyJson(data) {
  const rates = DISPLAY_ORDER.map((code) => {
    const node = data?.Valute?.[code];
    if (!node) return null;
    const nominal = Math.max(1, Number(node.Nominal) || 1);
    const value = Number(String(node.Value).replace(',', '.'));
    if (!value) return null;
    return {
      code,
      name: node.Name || code,
      nominal,
      value,
      rate_rub: Math.round((value / nominal) * 10000) / 10000,
    };
  }).filter(Boolean);

  let updated_at = data?.Date || '';
  if (updated_at) {
    const parsed = new Date(updated_at);
    if (!Number.isNaN(parsed.getTime())) {
      updated_at = parsed.toLocaleDateString('ru-RU');
    }
  }

  return { source: 'cbr', updated_at, rates };
}

export async function fetchCbrRatesFromWeb() {
  const res = await fetch(CBR_JSON_URL);
  if (!res.ok) {
    throw new Error('Не удалось получить курсы ЦБ РФ');
  }
  const data = await res.json();
  const mapped = mapCbrDailyJson(data);
  if (!mapped.rates.length) {
    throw new Error('В ответе ЦБ РФ нет нужных валют');
  }
  return mapped;
}

export function formatRate(rate) {
  const rub = Number(rate.rate_rub).toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  });
  if (rate.nominal > 1) {
    return `${rub} ₽ за ${rate.nominal} ${rate.code}`;
  }
  return `${rub} ₽`;
}
